// extracted by mini-css-extract-plugin
module.exports = {"c-services-bottom":"_025a50318d--c-services-bottom--16A6S","c-sms-form-image":"_025a50318d--c-sms-form-image--3Zify"};